import { useMemo } from "react";
import type { UserPlatformProfile } from "types/interfaces/user";
import { getNavCatalog, NavCatalog } from "utils/navModel";
import { useViewAs } from "./useViewAs";

export interface NavContext {
  catalog: NavCatalog;
  /** Whose pages these are: the viewed user inside the Client View shell. */
  shown: UserPlatformProfile | undefined;
  inShell: boolean;
}

/** The sidebar's and the home page's products for the page being shown. */
export function useNavCatalog(): NavContext {
  const { isClientView, profile, realProfile, basePath } = useViewAs();
  // The slice outlives the shell by a render after a browser Back, so only a
  // page inside the shell is seen through the viewed user (as in usePermissions).
  const inShell = isClientView && basePath !== "";
  return useMemo(() => {
    const shown = inShell ? profile : realProfile;
    return {
      inShell,
      shown,
      catalog: getNavCatalog(
        shown,
        inShell ? { basePath, viewer: realProfile } : undefined,
      ),
    };
  }, [inShell, profile, realProfile, basePath]);
}

export default useNavCatalog;
